import { Snackbar, Alert,useTheme, useMediaQuery } from '@mui/material'
import { AlertColor } from '@mui/material/Alert'
import { SnackbarCloseReason } from '@mui/material/Snackbar'
import { SyntheticEvent } from 'react'

interface CustomSnackbarProps {
  open: boolean
  message: string
  severity: AlertColor
  onClose?: (event: Event | SyntheticEvent , reason: SnackbarCloseReason) => void
  onAlertClose?: () => void
}

const CustomSnackbar = ({ open, message, severity, onClose, onAlertClose }: CustomSnackbarProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: isMobile ? 'center' : 'right',
      }}
      sx={{
        '.MuiSnackbar-root': {
          right: isMobile ? 'auto' : theme.spacing(3),
          left: isMobile ? '50%' : 'auto',
          transform: isMobile ? 'translateX(-50%)' : 'none',
        },
      }}
    >
      <Alert onClose={onAlertClose} severity={severity} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  )
}

export default CustomSnackbar
